import React, { useEffect, useState } from "react";
import "./Home.css";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";


const heroSlides = [
  {
    image: "/images/hero/curtain.jpg",
    text: "Curtain Design Specialists"
  },
  {
    image: "/images/hero/blinds.jpg",
    text: "Blind Installation Experts"
  },
  {
    image: "/images/hero/wallpaper.jpg",
    text: "Luxury Wallpaper Designers"
  },
  {
    image: "/images/hero/sofa.jpg",
    text: "Premium Sofa Fabric Solutions"
  },
  {
    image: "/images/hero/interior.jpg",
    text: "Home Interior Designers"
  }
];

export default function Home() {
  const [activeIndex, setActiveIndex] = useState(0);

  // ✅ Auto slide every 3.5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex(prev => (prev + 1) % heroSlides.length);
    }, 3500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="home-page">

      {/* ================= HERO SECTION ================= */}
      <section className="hero-section">

        {/* Background slider */}
        {heroSlides.map((slide, index) => (
          <div
            key={index}
            className={`hero-slide ${index === activeIndex ? "active" : ""}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          />
        ))}

        <div className="hero-overlay">
          <motion.div
            className="hero-content"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >

            {/* MAIN HEADING */}
            <h1 className="hero-title">
              Best&nbsp;
              {heroSlides[activeIndex].text}
              <br />
              <span>in Coimbatore</span>
            </h1>

            <p className="hero-subtitle">
              Curtains • Blinds • Wallpapers • Sofa Fabrics • Netlon Installation
            </p>

            <Link to="/contact" className="hero-btn">
              Get Free Interior Consultation
            </Link>

          </motion.div>
        </div>
      </section>

      {/* ================= MARQUEE SECTION ================= */}

      <section className="marquee-section">
        <div className="marquee">
          <span>
            PREMIUM INTERIORS • CUSTOM CURTAINS • LUXURY WALLPAPERS • MODERN BLINDS •
            SOFA FABRICS • NETLON INSTALLATION •
          </span>
        </div>
      </section>


      {/* ================= ABOUT SECTION ================= */}
      <motion.section className="about-section" initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}>
        <div className="about-image">
          <img src="/images/about-hero.jpg" alt="Interior Design Coimbatore" />
        </div>

        <div className="about-content">
          <h2>Premium Interior Decor Solutions for Modern Living</h2>
          <p>
            <strong>The Blessing Interiors</strong> is one of the trusted interior
            designers in Coimbatore, offering customized interior decor solutions
            for homes, apartments, villas, offices, and commercial spaces.
          </p>
          <p>
            We specialize in <strong>curtains, blinds, luxury wallpapers,
              sofa fabrics, and Netlon mosquito mesh installation</strong>,
            delivering elegant designs that enhance comfort, style, and
            functionality.
          </p>
        </div>
      </motion.section>

      {/* ================= SERVICES SECTION ================= */}
      <motion.section className="services-section" id="services" initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}>
        <h2>Our Interior Design Services</h2>

        <div className="services-grid" initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{
            visible: {
              transition: {
                staggerChildren: 0.15
              }
            }
          }}>

          <div className="service-card">
            <img src="/images/curtains.jpg" alt="Curtains in Coimbatore" />
            <h3>Custom Curtains & Drapes</h3>
            <p>
              Premium curtains in Coimbatore including eyelet, pleated,
              blackout and sheer curtains designed to suit modern interiors.
            </p>
          </div>

          <div className="service-card">
            <img src="/images/blinds.jpg" alt="Blinds Installation" />
            <h3>Window Blinds Installation</h3>
            <p>
              Roller blinds, zebra blinds, wooden blinds and vertical blinds
              for stylish window treatment solutions.
            </p>
          </div>

          <div className="service-card">
            <img src="/images/romanblinds/luxury-roman-blinds.jpg" alt="Mosquito Net Installation" />
            <h3>Roman Blinds</h3>
            <p>
              Roman blinds offer a perfect blend of style and function, with soft folds that enhance any space.
            </p>
          </div>


          <div className="service-card">
            <img src="/images/wallpaper.jpg" alt="3D Wallpaper Coimbatore" />
            <h3>Luxury & 3D Wallpapers</h3>
            <p>
              Wide range of 3D wallpapers, Korean wallpapers and textured
              wall coverings for living rooms and bedrooms.
            </p>
          </div>

          <div className="service-card">
            <img src="/images/sofa.jpg" alt="Sofa Fabric Reupholstery" />
            <h3>Sofa Fabrics & Re-Upholstery</h3>
            <p>
              High-quality sofa fabric replacement and reupholstery services
              for homes and offices.
            </p>
          </div>

          <div className="service-card">
            <img src="/images/net/custom-mosquito-net-pollachi.jpeg" alt="Mosquito Net Installation" />
            <h3>Mosquito Net</h3>
            <p>
              Netlon mosquito mesh installation for doors and windows using
              premium long-lasting materials.
            </p>
          </div>


        </div>
      </motion.section>

      {/* ================= HIGHLIGHT SECTION ================= */}
      <motion.section className="highlight-section" initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}>
        <div className="highlight-box">
          <h3>2000+</h3>
          <p>Happy Customers</p>
        </div>
        <div className="highlight-box">
          <h3>Premium</h3>
          <p>Quality Materials</p>
        </div>
        <div className="highlight-box">
          <h3>Expert</h3>
          <p>Installation Team</p>
        </div>
        <div className="highlight-box">
          <h3>Affordable</h3>
          <p>Interior Packages</p>
        </div>
      </motion.section>

      {/* ================= HOME SEO TRUST SECTION ================= */}
      <section className="home-seo-trust">
        <div className="home-seo-container">

          <div className="home-seo-heading">
            <h2>
              Trusted Interior Designers in Coimbatore for Elegant Living Spaces
            </h2>
            <p>
              We design interiors that feel comfortable, look elegant, and last long.
            </p>
          </div>

          <div className="home-seo-grid">

            <div className="home-seo-card">
              <h3>Customized Interior Solutions</h3>
              <p>
                Every home is unique, and so is our design approach. We create
                customized interior décor solutions based on your lifestyle,
                preferences, and space usage — ensuring comfort and functionality.
              </p>
            </div>

            <div className="home-seo-card highlight">
              <h3>Premium Materials & Clean Finishing</h3>
              <p>
                From curtains and blinds to wallpapers and sofa fabrics, we use
                carefully selected premium materials. Our professional installation
                ensures neat finishing and long-lasting quality.
              </p>
            </div>

            <div className="home-seo-card">
              <h3>End-to-End Interior Services</h3>
              <p>
                We handle everything from consultation and material selection to
                measurement and installation. This makes us a one-stop interior
                solution provider in Coimbatore.
              </p>
            </div>

            <div className="home-seo-card highlight">
              <h3>Residential & Commercial Expertise</h3>
              <p>
                Our interior design services are trusted by homeowners, apartment
                owners, offices, and commercial spaces across Coimbatore.
              </p>
            </div>

            <div className="home-seo-card">
              <h3>Affordable & Transparent Pricing</h3>
              <p>
                We believe premium interiors should be accessible. Our pricing is
                transparent, honest, and tailored to your budget without compromising
                quality.
              </p>
            </div>

            <div className="home-seo-card highlight">
              <h3>Experienced Interior Installation Team</h3>
              <p>
                Our skilled team ensures accurate measurements, professional
                execution, and on-time project completion for every interior work.
              </p>
            </div>

          </div>

        </div>
      </section>


      {/* ================= INTERIOR STYLES ================= */}
      <motion.section
        className="styles-section"
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <h2>Interior Styles We Specialize In</h2>

        <div className="styles-marquee">
          <div className="styles-track">
            {/* duplicate images for infinite scroll */}
            <img src="/images/curtains/designer-curtains-coimbatore.jpg" alt="Modern Interior Design" />
            <img src="/images/pvcblinds/custom-blinds-for-living-room-coimbatore.jpg" alt="Classic Interior Design" />
            <img src="/images/rollerblinds/custom-roller-blinds.jpg" alt="Luxury Interior Design" />
            <img src="/images/romanblinds/roman-blinds-for-living-room-coimbatore.jpg" alt="Minimal Interior Design" />
            <img src="/images/sofa/living-room-sofa-pollachi.jpg" alt="Modern Interior Design" />
            <img src="/images/veniciantblinds/venetian-blinds-installation-coimbatore.jpg" alt="Classic Interior Design" />
            <img src="/images/wallpaper/luxury-wallpaper-design-coimbatore.jpg" alt="Luxury Interior Design" />
            <img src="/images/zebrablinds/best-zebra-blinds-pollachi.jpg" alt="Minimal Interior Design" />
          </div>
        </div>
      </motion.section>


      {/* ================= CTA SECTION ================= */}
      <motion.section className="cta-section" initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}>
        <h2>Looking for the Best Interior Designers Near You?</h2>
        <p>
          Get professional interior decoration services with premium materials,
          creative designs, and expert installation.
        </p>
        <Link to="/contact" className="cta-btn">Book Free Site Visit</Link>
      </motion.section>
    </div>
  );
}